(() => {
  'use strict';

  /*
  ============================================================
  OLDALTÍPUSOK
  ============================================================
  */

  const pageTypeOptions = [
    {
      id: 'home',
      name: 'Főoldal',
      description:
        'A Shopify webshop elsődleges belépőoldala és legfontosabb értékesítési felülete.',
      defaultQuantity: 1,
      minimum: 1,
      maximum: 1,
      required: true,
      recommended: true,
      locked: true,
      group: 'core'
    },
    {
      id: 'about',
      name: 'Rólunk',
      description:
        'A márka, a vállalkozás, a csapat vagy a történet bemutatása.',
      defaultQuantity: 1,
      minimum: 0,
      maximum: 3,
      required: false,
      recommended: true,
      locked: false,
      group: 'core'
    },
    {
      id: 'contact',
      name: 'Kapcsolat',
      description:
        'Kapcsolati adatok, kapcsolatfelvételi űrlap, térkép és elérhetőségek.',
      defaultQuantity: 1,
      minimum: 0,
      maximum: 3,
      required: false,
      recommended: true,
      locked: false,
      group: 'core'
    },
    {
      id: 'faq',
      name: 'GYIK',
      description:
        'Gyakori kérdések és válaszok külön, könnyen áttekinthető oldalon.',
      defaultQuantity: 1,
      minimum: 0,
      maximum: 3,
      required: false,
      recommended: true,
      locked: false,
      group: 'support'
    },
    {
      id: 'shipping-payment',
      name: 'Szállítás és fizetés',
      description:
        'Szállítási módok, fizetési lehetőségek, határidők és kapcsolódó információk.',
      defaultQuantity: 1,
      minimum: 0,
      maximum: 3,
      required: false,
      recommended: true,
      locked: false,
      group: 'commerce'
    },
    {
      id: 'returns',
      name: 'Visszaküldés és garancia',
      description:
        'Elállási, visszaküldési, csere- és garanciális információk.',
      defaultQuantity: 1,
      minimum: 0,
      maximum: 3,
      required: false,
      recommended: true,
      locked: false,
      group: 'commerce'
    },
    {
      id: 'services',
      name: 'Szolgáltatások',
      description:
        'Szolgáltatási összefoglaló vagy több különálló szolgáltatásoldal.',
      defaultQuantity: 0,
      minimum: 0,
      maximum: 30,
      required: false,
      recommended: false,
      locked: false,
      group: 'content'
    },
    {
      id: 'landing',
      name: 'Landing oldalak',
      description:
        'Kampány-, ajánlat- vagy konverzióközpontú egyedi oldalak.',
      defaultQuantity: 0,
      minimum: 0,
      maximum: 30,
      required: false,
      recommended: false,
      locked: false,
      group: 'content'
    },
    {
      id: 'editorial',
      name: 'Tartalmi oldalak',
      description:
        'Bemutató, információs, magazin- vagy történetmesélő oldalak.',
      defaultQuantity: 0,
      minimum: 0,
      maximum: 50,
      required: false,
      recommended: false,
      locked: false,
      group: 'content'
    },
    {
      id: 'blog-index',
      name: 'Blog főoldal',
      description:
        'Cikkek, hírek, útmutatók vagy magazintartalmak listázóoldala.',
      defaultQuantity: 0,
      minimum: 0,
      maximum: 1,
      required: false,
      recommended: false,
      locked: false,
      group: 'content'
    },
    {
      id: 'support',
      name: 'Ügyféltámogatás',
      description:
        'Segítség, dokumentáció, használati útmutatók vagy ügyfélszolgálati információk.',
      defaultQuantity: 0,
      minimum: 0,
      maximum: 10,
      required: false,
      recommended: false,
      locked: false,
      group: 'support'
    },
    {
      id: 'legal',
      name: 'Jogi oldalak',
      description:
        'ÁSZF, adatkezelés, sütik, elállási tájékoztató és egyéb kötelező dokumentumok.',
      defaultQuantity: 4,
      minimum: 0,
      maximum: 12,
      required: false,
      recommended: true,
      locked: false,
      group: 'legal'
    },
    {
      id: 'other',
      name: 'Egyéb egyedi oldalak',
      description:
        'Minden további, önálló tervezést és felépítést igénylő oldal.',
      defaultQuantity: 0,
      minimum: 0,
      maximum: 50,
      required: false,
      recommended: false,
      locked: false,
      group: 'other'
    }
  ];

  /*
  ============================================================
  OLDALCSOPORTOK
  ============================================================
  */

  const pageGroups = [
    {
      id: 'core',
      name: 'Alapoldalak',
      description:
        'A Shopify webshop általánosan ajánlott, alapvető oldalai.',
      recommended: true
    },
    {
      id: 'commerce',
      name: 'Vásárlási információk',
      description:
        'A rendeléshez, szállításhoz, fizetéshez és garanciához kapcsolódó oldalak.',
      recommended: true
    },
    {
      id: 'content',
      name: 'Tartalmi oldalak',
      description:
        'Szolgáltatási, kampány-, blog- és egyéb tartalmi oldalak.',
      recommended: false
    },
    {
      id: 'support',
      name: 'Támogatási oldalak',
      description:
        'GYIK, dokumentáció, segítség és ügyféltámogatás.',
      recommended: true
    },
    {
      id: 'legal',
      name: 'Jogi oldalak',
      description:
        'Kötelező jogi, adatvédelmi és vásárlási tájékoztatók.',
      recommended: true
    },
    {
      id: 'other',
      name: 'További oldalak',
      description:
        'Minden további, egyedileg megadott vagy számszerűsített oldal.',
      recommended: false
    }
  ];

  /*
  ============================================================
  SAJÁT OLDALAK
  ============================================================
  */

  const customPageOptions = {
    enabled: true,

    maximumPages: 30,

    name: {
      minimumLength: 2,
      maximumLength: 80,
      placeholder:
        'Például: Nagykereskedelmi jelentkezés'
    },

    description: {
      maximumLength: 240,
      placeholder:
        'Röviden írd le, mi legyen az oldal feladata.'
    },

    duplicateNamesAllowed: false,

    defaultPages: []
  };

  /*
  ============================================================
  KATALÓGUSMÉLYSÉG
  ============================================================
  */

  const catalogDepthOptions = [
    {
      id: 'none',
      level: 0,
      name: 'Nincs termékkatalógus',
      shortName: 'Nincs',
      description:
        'A projekt nem tartalmaz értékesíthető termékeket vagy termékkatalógust.',
      path: [
        'Egyedi oldalak'
      ],
      recommendedFor:
        'Olyan oldalhoz, amely nem Shopify-webshopként működik.',
      recommended: false,
      badge: ''
    },
    {
      id: 'simple',
      level: 1,
      name: 'Egyszerű katalógus',
      shortName: 'Egyszerű',
      description:
        'A vásárló közvetlenül a terméklistából jut el az egyes termékekhez.',
      path: [
        'Terméklista',
        'Termék'
      ],
      recommendedFor:
        'Kisebb, könnyen áttekinthető és kevés kategóriát használó kínálat.',
      recommended: false,
      badge: ''
    },
    {
      id: 'categorized',
      level: 2,
      name: 'Kategorizált katalógus',
      shortName: 'Kategorizált',
      description:
        'A termékek fő kategóriákba rendezve jelennek meg, majd innen érhetők el a termékoldalak.',
      path: [
        'Katalógus',
        'Főkategória',
        'Termék'
      ],
      recommendedFor:
        'A legtöbb kis- és közepes Shopify-webshop számára.',
      recommended: true,
      badge: 'Ajánlott'
    },
    {
      id: 'deep',
      level: 3,
      name: 'Többszintű katalógus',
      shortName: 'Többszintű',
      description:
        'Főkategóriák, alkategóriák és kollekciók tagolják a kínálatot.',
      path: [
        'Katalógus',
        'Főkategória',
        'Alkategória',
        'Kollekció',
        'Termék'
      ],
      recommendedFor:
        'Nagyobb választékhoz és több szintű terméknavigációhoz.',
      recommended: false,
      badge: ''
    },
    {
      id: 'complex',
      level: 4,
      name: 'Komplex katalógus',
      shortName: 'Komplex',
      description:
        'Márka-, kategória-, alkategória- és termékcsalád-szintű rendszer.',
      path: [
        'Katalógus',
        'Márka',
        'Főkategória',
        'Alkategória',
        'Termékcsalád',
        'Termék'
      ],
      recommendedFor:
        'Nagy termékszámhoz, több márkához és összetett kínálathoz.',
      recommended: false,
      badge: ''
    }
  ];

  /*
  ============================================================
  KATALÓGUS RÉSZLETEI
  ============================================================
  */

  const catalogFields = [
    {
      id: 'mainCategoryCount',
      name: 'Főkategóriák száma',
      description:
        'A katalógus legfelső, vásárlók számára látható kategóriaszintje.',
      minimum: 1,
      maximum: 100,
      defaultValue: 5,
      visibleFromLevel: 2
    },
    {
      id: 'subCategoryCount',
      name: 'Alkategóriák száma',
      description:
        'A főkategóriák alatt megjelenő további termékcsoportok.',
      minimum: 0,
      maximum: 500,
      defaultValue: 0,
      visibleFromLevel: 3
    },
    {
      id: 'collectionCount',
      name: 'Kollekciók száma',
      description:
        'Tematikus, szezonális vagy üzleti logika szerint létrehozott gyűjtemények.',
      minimum: 0,
      maximum: 500,
      defaultValue: 0,
      visibleFromLevel: 3
    },
    {
      id: 'brandCount',
      name: 'Márkák száma',
      description:
        'Külön márkaoldallal vagy márkaszűréssel kezelt gyártók.',
      minimum: 0,
      maximum: 500,
      defaultValue: 0,
      visibleFromLevel: 4
    },
    {
      id: 'productFamilyCount',
      name: 'Termékcsaládok száma',
      description:
        'Egymáshoz tartozó modell-, sorozat- vagy termékcsoportok.',
      minimum: 0,
      maximum: 1000,
      defaultValue: 0,
      visibleFromLevel: 4
    }
  ];

  /*
  ============================================================
  TERMÉKFELTÖLTÉS
  ============================================================
  */

  const productOptions = {
    productCount: {
      id: 'productCount',

      name:
        'Feltöltendő termékek száma',

      description:
        'Csak akkor kell megadni, amikor a ZLN csapatára bízod a termékek feltöltését.',

      minimum: 0,
      maximum: 100000,
      defaultValue: 0,

      requiresUploadService: true,
      disabledUntilUploadService: true,

      resetWhenUploadDisabled: true
    },

    uploadService: {
      id: 'uploadService',

      name:
        'Termékfeltöltési szolgáltatás',

      question:
        'Szeretnéd, hogy mi töltsük fel a termékeket?',

      description:
        'A ZLN csapata a megadott termékadatok, képek, árak, variánsok és kategóriák alapján feltölti és rendszerezi a kínálatot.',

      defaultValue: false,

      enabledLabel:
        'Igen, kérem a termékfeltöltést',

      disabledLabel:
        'Nem kérem a termékfeltöltést'
    }
  };

  /*
  ============================================================
  ÁRKÉPZÉSI ADATOK

  A jelenlegi működési JavaScript kompatibilitása miatt megmarad.
  A publikus megjelenítést a Liquid fájlból külön fogjuk kivenni.
  ============================================================
  */

  const pricing = {
    currency: 'HUF',
    locale: 'hu-HU',

    developmentBaseFrom: 1000000,

    productUploadTiers: [
      {
        from: 1,
        to: 200,
        unitPrice: 5000
      },
      {
        from: 201,
        to: null,
        unitPrice: 3000
      }
    ],

    notes: [
      'A fejlesztési alapár tájékoztató jellegű.',
      'A termékfeltöltés külön szolgáltatás.',
      'A végleges díjat a termékadatok mennyisége, minősége és összetettsége határozza meg.',
      'A végleges ajánlatot a részletes struktúra és az egyedi működési igények alapján készítjük el.'
    ]
  };

  /*
  ============================================================
  ÖSSZESÍTŐ CÍMKÉK
  ============================================================
  */

  const summaryLabels = {
    recommendedStructure:
      'Ajánlott alapstruktúra',

    standardPages:
      'Általános oldalak',

    customPages:
      'Saját oldalak',

    uniquePages:
      'Egyedi oldalak',

    dynamicProductPages:
      'Dinamikus termékoldalak',

    catalogDepth:
      'Katalógus mélysége',

    recommendedCatalog:
      'Ajánlott katalógus',

    mainCategories:
      'Főkategóriák',

    subCategories:
      'Alkategóriák',

    collections:
      'Kollekciók',

    brands:
      'Márkák',

    productFamilies:
      'Termékcsaládok',

    products:
      'Feltöltendő termékek',

    uploadService:
      'Termékfeltöltés',

    uploadRequested:
      'Kért szolgáltatás',

    uploadNotRequested:
      'Nem kért szolgáltatás',

    developmentBase:
      'Fejlesztési alapár',

    uploadFee:
      'Termékfeltöltési díj',

    estimatedTotal:
      'Becsült induló összeg',

    finalQuoteNotice:
      'A végleges ajánlat a részletes struktúra, a termékadatok és az egyedi fejlesztési igények felmérése után készül el.'
  };

  /*
  ============================================================
  ALAPÉRTELMEZETT ÁLLAPOT
  ============================================================
  */

  const defaultStructure = {
    structureMode:
      'recommended',

    pageQuantities:
      pageTypeOptions.reduce(
        (
          result,
          option
        ) => {
          result[option.id] =
            option.defaultQuantity;

          return result;
        },
        {}
      ),

    customPages:
      customPageOptions.defaultPages.slice(),

    catalogDepthId:
      'categorized',

    catalog:
      catalogFields.reduce(
        (
          result,
          field
        ) => {
          result[field.id] =
            field.defaultValue;

          return result;
        },
        {}
      ),

    productCount:
      productOptions
        .productCount
        .defaultValue,

    uploadService:
      productOptions
        .uploadService
        .defaultValue,

    notes:
      ''
  };

  /*
  ============================================================
  PUBLIKUS ADATOBJEKTUM
  ============================================================
  */

  window.ZLN_LABOR_STRUCTURE_DATA = {
    version: 2,

    step: {
      id:
        'structure',

      index:
        3,

      eyebrow:
        '03 / Struktúralabor',

      title:
        'Állítsd össze a webshop struktúráját.',

      description:
        'Indulj az ajánlott általános struktúrából, adj hozzá saját oldalakat, majd válaszd ki a termékkatalógus megfelelő mélységét.'
    },

    pageGroups,
    pageTypeOptions,
    customPageOptions,
    catalogDepthOptions,
    catalogFields,
    productOptions,
    pricing,
    summaryLabels,
    defaultStructure
  };

  /*
  ============================================================
  ADATFÁJL BETÖLTÉSI ESEMÉNY
  ============================================================
  */

  document.dispatchEvent(
    new CustomEvent(
      'zln:labor-structure-data-ready',
      {
        detail: {
          version:
            window
              .ZLN_LABOR_STRUCTURE_DATA
              .version,

          pageTypeCount:
            pageTypeOptions.length,

          recommendedPageCount:
            pageTypeOptions.filter(
              (option) => {
                return option.recommended;
              }
            ).length,

          catalogDepthCount:
            catalogDepthOptions.length,

          recommendedCatalogDepth:
            catalogDepthOptions.find(
              (option) => {
                return option.recommended;
              }
            )?.id || null,

          customPagesEnabled:
            customPageOptions.enabled
        }
      }
    )
  );
})();